<!--
    描述：造价总览 下方表格模块
    时间：2020-06-05
    Created by ws
-->
<template>
    <div class="baseTab-layout">
        <!-- 上方表单内容 -->
        <div class="baseTab-top">
            <el-form label-width="110px"
                     :model="formInfo">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="编制单位:">{{ formInfo.companyName }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="编制人:">{{ formInfo.taskUser }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="编制日期:">{{ formInfo.editDate ? formInfo.editDate.slice(0, 10) : '' }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="清单定额依据:">{{ formInfo.underGroundMechine }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="信息价:">{{ formInfo.basisQuotaName.split(",")[0] }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="计价软件:">{{ formInfo.softwareName }}</el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- 下方表格 -->
        <div class="baseTab-content pdb5">
            <div class="w-table-layout">
                <div class="w-table-content"
                     ref="tableContent">
                    <!-- 树形表格 -->
                    <el-table :data="treeData"
                              row-key="id"
                              ref="xTable"
                              :height="tableH"
                              border
                              stripe
                              v-loading="loading"
                              highlight-current-row
                              :expand-row-keys="expandKeys"
                              :row-class-name="rowClassName"
                              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                        <el-table-column prop="projectName"
                                         label="项目名称"
                                         show-overflow-tooltip
                                         min-width="150">
                            <template slot="header"
                                      slot-scope="scope">
                                <span class="select-label">项目名称</span>
                                <el-select v-model="curLevel"
                                           class="ml10 select-width"
                                           placeholder="请选择"
                                           size="small"
                                           @change="onChangeLevel">
                                    <el-option :value="0"
                                               label="展开到一级"></el-option>
                                    <el-option :value="1"
                                               label="展开到二级"></el-option>
                                    <el-option :value="2"
                                               label="展开到三级"></el-option>
                                    <el-option :value="3"
                                               label="展开到四级"></el-option>
                                </el-select>
                            </template>
                            <template slot-scope="scope">
                                {{ scope.row.infoName }}
                                <el-tooltip placement="right"
                                            effect="light"
                                            v-if="scope.row.tags !== '' && [0, 1].includes(scope.row.levelType)">
                                    <div slot="content"
                                            class="tag-label-tooltip">
                                        <el-tag class="mr10 mb10"
                                                size="mini"
                                                v-for="(item, index) in toArray(scope.row.tags)"
                                                :key="index">{{ item }}</el-tag>
                                    </div>
                                    <svg-icon icon-class="biaoqian"
                                                class="ml5"></svg-icon>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cost"
                                         min-width="70"
                                         header-align="center"
                                         align="right"
                                         show-overflow-tooltip
                                         label="填报金额">
                        </el-table-column>
                        <el-table-column prop="costbus"
                                         min-width="70"
                                         header-align="center"
                                         align="right"
                                         show-overflow-tooltip
                                         label="文件读取金额">
                        </el-table-column>
                        <el-table-column prop="fileName"
                                         min-width="100"
                                         show-overflow-tooltip
                                         header-align="center"
                                         align="left"
                                         label="源文件">
                            <template slot-scope="scope">
                                <a class="rowName">{{ scope.row.fileName }}</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="upUserName"
                                         min-width="70"
                                         align="center"
                                         label="上传人">
                        </el-table-column>
                        <el-table-column prop="uploadDate"
                                         min-width="70"
                                         show-overflow-tooltip
                                         align="center"
                                         label="上传时间">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {exportExcel, dateFormat} from '@/utils/tools'

    export default {
        props: {
            // 表单信息
            formInfo: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            // 表格数据
            tableData: {
                type: Array,
                default: () => {
                    return []
                }
            },
            // 原始数据（导出用）
            tableList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                tableH: 100, // 表格高度
                treeData: [],
                expandKeys: [],
                curLevel: 2,
                loading: false
            }
        },
        methods: {
            // 行样式
            rowClassName({row, rowIndex}) {
                if (row.levelType === 0) {
                    return 'project-row'
                } else if (row.levelType === 1) {
                    return 'single-row'
                } else if (row.levelType === 2) {
                    return 'unit-row'
                }
                return ''
            },

            // 导出Excel
            doExport(fileName, type) {
                let saveName = fileName + dateFormat('yyyy-MM-dd hh:ss:mm');
                let params = {
                    basicInfo: this.formInfo,
                    list: this.tableList,
                    type: type,
					projectId : this.curProjectId,
                    saveName: saveName
                }
                exportExcel('busCostDetail/projectCostExportExcle', params, saveName)
            },

            // 点击切换展开层级
            onChangeLevel(val) {
                this.loading = true
                // 先清空
                this.treeData = []
                this.expandKeys = []

                // 设置 level
                let _data = JSON.parse(JSON.stringify(this.tableData))
                this.expandLevel(_data, val, this.expandKeys)

                // 展示表格
                setTimeout(() => {
                    this.loading = false
                    this.treeData = this.tableData
                    this.$refs.xTable ? this.$refs.xTable.doLayout() : ''
                }, 500)
            },

            // 默认key 值展开
            expandLevel(arr, level, backArr) {
                if (arr.length > 0) {
                    arr.forEach(x => {
                        if (x.children && x.levelType < level) {
                            backArr.push(x.id)
                            this.expandLevel(x.children, level, backArr)
                        }
                    })
                }
            },

            // 展示标签
            toArray(str) {
                let arr = str.split(',').filter((x) => x !== '')
                return arr
            },
        },
        created() {
            this.$nextTick(() => {
                this.tableH = this.$refs.tableContent.offsetHeight
            })
        },
        computed: {
            ...mapState('app', {
                clientSize: state => state.clientSize
            }),
			// 当前项目ID
			curProjectId() {
				return this.$route.query.projectId
			},
        },
        watch: {
            clientSize(obj) {
                this.tableH = this.$refs.tableContent.offsetHeight
            },
            tableData: {
                handler: function (val) {
                    this.tableH = this.$refs.tableContent.offsetHeight
                    this.onChangeLevel(2)
                },
                deep: true
            }
        }
    }
</script>

<style lang="less" scoped>
    .baseTab-layout {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;

        .baseTab-top {
            padding: 5px 0;
        }

        .baseTab-content {
            flex: 1;
            overflow: auto;
        }
    }

    .select-label {
        display: inline-block;
        line-height: 32px;
    }

    .select-width {
        width: 150px;
        float: right;
    }
</style>
